export enum InvoiceTypeEnum {
    INVOICE = 'INVOICE',
    CREDIT_NOTE = 'CREDIT_NOTE',
    RECEIPT = 'RECEIPT'
}
